
import Vue from 'vue';
import Vuex from 'vuex';
import personasArray from '../config/home/index'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        personasArray,
        selectedPersonaIndex: null,
        personaPrefix: "",
        sagePeoplePage: '',
        personaDataAction: '',
        welcome: true,
        areWeTracking: true,
        gateId: '',
        primary: 'STORE LOADED',
        todos: [],
        logs: []
    }
})